import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-patch-icon',
  templateUrl: './design-patch.component.html'
})
export class DesignPatchComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
